import { Injectable } from '@angular/core';
import { AuthService } from 'app/services/auth/auth.service';
import { TenantService } from 'app/services/tenant/tenant.service';
import { environment } from 'environments/environment';
import { resolveGainsEnvironment } from 'app/shared/util/gains-environment.util';

@Injectable({
  providedIn: 'root'
})
export class HeaderBuilderService {
  constructor(
    private readonly _authService: AuthService,
    private readonly _tenantService: TenantService
  ) {}

  /**
   * Build all standard headers for API requests.
   * x-gains-tenant-id contains the tenant ID, while x-gains-tenant contains the customer name.
   */
  buildHeaders(): Record<string, string> {
    const headers: Record<string, string> = {};

    const token = this._authService.getToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const email = this._authService.getEmail();
    if (email) {
      headers['x-gains-user-email'] = email;
    }

    const userName = this._authService.getUsername();
    if (userName) {
      headers['x-gains-user-name'] = userName;
    }

    const tenantId = this._tenantService.getSelectedTenant();
    const customerName = this._tenantService.getSelectedCustomerName();
    if (tenantId) {
      headers['x-gains-tenant-id'] = tenantId;
    }

    if (customerName) {
      headers['x-gains-tenant'] = customerName;
    } else if (tenantId) {
      headers['x-gains-tenant'] = tenantId;
    }

    headers['x-gains-environment'] = resolveGainsEnvironment(environment.environmentId);

    return headers;
  }

  /**
   * Check if user has a valid token
   */
  hasValidToken(): boolean {
    return !!this._authService.getToken();
  }
}
